import React, { useEffect, useState } from "react";
import NavMenu from "./Nav";
import servicosAtribuicao from "../../servicos/servicos-atribuicao";
import servicosColaborador from "../../servicos/servicos-colaborador";
import MenuLateral from "./MenuLateral";
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import { toast, ToastContainer } from "react-toastify";
import CheckAll from "../../img/svgs/CheckAll";
import Salvar from "../../img/svgs/Salvar";
import Mobile from "../../img/svgs/Mobile";
import Clock from "../../img/svgs/Clock";
import Adjust from "../../img/svgs/Adjust";
import Headset from "../../img/svgs/Headset";
import Spinner from "./Spinner";

const AtribuicaoMilhas = () => {
    const [colaboradores, setColaboradores] = useState([]);
    const [listaFiltrada, setListaFiltrada] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const idAjuste = 329;
    const idAtraso = 330;
    const idBatida = 331;
    const idPlantao = 332;

    useEffect(() => {
        function getDados() {
            setIsLoading(true);
            servicosColaborador.listarTodos()
                .then(response => {
                    if (response.status === 200) {
                        let listaColab = [];
                        response.data.map(item => {
                            if (item.Cargo[0].id_cargo !== 43 && item.Cargo[0].id_cargo !== 50) {
                                return listaColab.push(item);
                            } else {
                                return '';
                            }
                        })
                        setColaboradores(listaColab);
                        setTimeout(() => {
                            setIsLoading(false);
                          }, 1000);
                    }
                }).catch((error) => {
                    console.log(error);
                });
        }
        getDados();
    }, []);




    async function atribuicaoMultipla() {
        const errosAtribuicoes = [];

        const listaSelecionadosAtraso = [];
        colaboradores.forEach(colaborador => {
            const elementoWeb = document.querySelector(`#atraso${colaborador.id_colaborador}`);
            if (elementoWeb?.checked === true) {
                listaSelecionadosAtraso.push(elementoWeb.value)
            }
        });

        const listaSelecionadosAjuste = [];
        colaboradores.forEach(colaborador => {
            const elementoWeb = document.querySelector(`#ajuste${colaborador.id_colaborador}`);
            if (elementoWeb?.checked === true) {
                listaSelecionadosAjuste.push(elementoWeb.value)
            }
        });


        const listaSelecionadosBatida = [];
        colaboradores.forEach(colaborador => {
            const elementoWeb = document.querySelector(`#batida_remota${colaborador.id_colaborador}`);
            if (elementoWeb?.checked === true) {
                listaSelecionadosBatida.push(elementoWeb.value)
            }
        });

        const listaSelecionadosPlantao = [];
        colaboradores.forEach(colaborador => {
            const elementoWeb = document.querySelector(`#plantao${colaborador.id_colaborador}`);
            if (elementoWeb?.checked === true) {
                listaSelecionadosPlantao.push(elementoWeb.value)
            }
        });

        async function aguardaAtraso() {
            for (const i of listaSelecionadosAtraso) {
                const dataAtribuicao = {
                    "id_colaborador": Number(i),
                    "id_motivo": idAtraso,
                    "data": new Date()
                }

                servicosAtribuicao.create(dataAtribuicao)
                    .then(response => {
                        if (response.status === 201) {
                            let aux = document.querySelector(`#atraso${dataAtribuicao.id_colaborador}`);
                            aux.checked = false;
                        }
                    })
                    .catch(e => {
                        console.log(e);
                        const colaborador = {
                            id_colaborador: Number(i),
                            id_motivo: idAtraso
                        };
                        errosAtribuicoes.push(colaborador)
                    })

            }

        }

        async function aguardaAjuste() {
            for await (const i of listaSelecionadosAjuste) {
                const dataAtribuicao = {
                    "id_colaborador": Number(i),
                    "id_motivo": idAjuste,
                    "data": new Date()
                }
                await servicosAtribuicao.create(dataAtribuicao)
                    .then(response => {
                        if (response.status === 201) {
                            let aux = document.querySelector(`#ajuste${dataAtribuicao.id_colaborador}`);
                            aux.checked = false;
                        }
                    })
                    .catch(e => {
                        console.log(e);
                        const colaborador = {
                            id_colaborador: Number(i),
                            id_motivo: idAjuste
                        };
                        errosAtribuicoes.push(colaborador);
                    })
            }
        }

        async function aguardaBatida() {
            for await (const i of listaSelecionadosBatida) {
                const dataAtribuicao = {
                    "id_colaborador": Number(i),
                    "id_motivo": idBatida,
                    "data": new Date()
                }
                await servicosAtribuicao.create(dataAtribuicao)
                    .then(response => {
                        if (response.status === 201) {
                            let aux = document.querySelector(`#batida_remota${dataAtribuicao.id_colaborador}`);
                            aux.checked = false;
                        }
                    })
                    .catch(e => {
                        console.log(e);
                        const colaborador = {
                            id_colaborador: Number(i),
                            id_motivo: idBatida
                        };
                        errosAtribuicoes.push(colaborador);
                    });

            }
        }

        async function aguardaPlantao() {
            for await (const i of listaSelecionadosPlantao) {
                const dataAtribuicao = {
                    "id_colaborador": Number(i),
                    "id_motivo": idPlantao,
                    "data": new Date()
                }

                await servicosAtribuicao.create(dataAtribuicao)
                    .then(response => {
                        if (response.status === 201) {
                            let aux = document.querySelector(`#plantao${dataAtribuicao.id_colaborador}`);
                            aux.checked = false;
                        }
                    })
                    .catch(e => {
                        console.log(e);
                        const colaborador = {
                            id_colaborador: Number(i),
                            id_motivo: idBatida
                        };
                        errosAtribuicoes.push(colaborador);
                    });
            }
        }
        async function finalizar() {
            toast.warning('Processo de atribuição iniciado, por favor aguarde!');
            await aguardaAjuste();
            await aguardaBatida();
            await aguardaAtraso();
            await aguardaPlantao();
            toast.success('Processo de atribuição finalizado!', {
                theme: 'colored'
            });
        }

        await finalizar();

    }

    const selecionarTodosAtraso = () => {
        colaboradores.forEach(colaborador => {
            const elementoWeb = document.querySelector(`#atraso${colaborador.id_colaborador}`);
            if (elementoWeb.checked === false) {
                elementoWeb.checked = true;
            } else {
                elementoWeb.checked = false
            }
        });
    }

    const selecionarTodosBatida = () => {

        colaboradores.forEach(colaborador => {
            const elementoWeb = document.querySelector(`#batida_remota${colaborador.id_colaborador}`);
            if (elementoWeb.checked === true) {
                elementoWeb.checked = false
            } else {
                elementoWeb.checked = true
            }
        });
    }

    const selecionarTodosAjuste = () => {
        colaboradores.forEach(colaborador => {
            const elementoWeb = document.querySelector(`#ajuste${colaborador.id_colaborador}`);
            if (elementoWeb.checked === true) {
                elementoWeb.checked = false
            } else {
                elementoWeb.checked = true
            }
        });

    }

    const selecionarTodosPlantao = () => {
        colaboradores.forEach(colaborador => {
            const elementoWeb = document.querySelector(`#plantao${colaborador.id_colaborador}`);
            if (elementoWeb.checked === true) {
                elementoWeb.checked = false
            } else {
                elementoWeb.checked = true
            }
        });

    }

    const handlePesquisa = (e) => {
        const pesquisa = e.target.value;
        let listaAtualizada = [];
        if (pesquisa !== "") {
            listaAtualizada = colaboradores.filter((item) => {
                return String(item.nome).toLowerCase().indexOf(pesquisa.toLowerCase()) !== -1;
            })
            setListaFiltrada(listaAtualizada);
        } else {
            setListaFiltrada(colaboradores);
        }

    }

    return <>
        <NavMenu />
        <ToastContainer />

        {isLoading ? <div className="container mt-5 d-flex justify-content-center align-items-center"><Spinner mensagem="Carregando lista de colaboradores" /></div> : <div className="d-flex container">

            <div className="w-25">
                <MenuLateral />
            </div>

            <div className="w-75 d-flex row justify-content-center mt-3">

                <div>
                    <span className="">Busca:</span> <input
                        className="rounded-5 border-1 ms-1"
                        type="text"
                        id="pesquisa"
                        style={{ width: 200 }}
                        onChange={handlePesquisa}
                    />
                </div>
                <Table striped bordered hover responsive className="mt-2 tabela-atribuicao">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Ajuste Ponto<button className="rounded px-1 btn-icones border-1" onClick={selecionarTodosAjuste}><CheckAll /><span className="text-dark"></span></button></th>
                            <th>Atraso<button className="rounded px-1 btn-icones border-1" onClick={selecionarTodosAtraso}><CheckAll /><span className="text-dark"></span></button></th>
                            <th>Batida Remota<button className="rounded px-1 btn-icones border-1" onClick={selecionarTodosBatida}><CheckAll /><span className="text-dark"></span></button></th>
                            <th>Plantão<button className="rounded px-1 btn-icones border-1" onClick={selecionarTodosPlantao}><CheckAll /><span className="text-dark"></span></button></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            listaFiltrada.length >= 1 ? (listaFiltrada.map(colaborador => (

                                <tr key={colaborador.id_colaborador} id={colaborador.id_colaborador}>
                                    <td>{colaborador.nome}</td>
                                    <td>
                                        <Form.Check
                                            className="text-center"
                                            type="switch"
                                            id={"ajuste" + colaborador.id_colaborador}
                                            label={<span>{<Adjust />} Sem ajuste</span>}
                                            value={colaborador.id_colaborador}
                                        />
                                    </td>
                                    <td>
                                        <Form.Check
                                            className="text-center"
                                            type="switch"
                                            id={"atraso" + colaborador.id_colaborador}
                                            label={<span>{<Clock />} Sem atraso</span>}
                                            value={colaborador.id_colaborador}
                                        />
                                    </td>
                                    <td>
                                        <Form.Check
                                            className="text-center"
                                            type="switch"
                                            id={"batida_remota" + colaborador.id_colaborador}
                                            label={<span>{<Mobile />} Sem batida remota</span>}
                                            value={colaborador.id_colaborador}
                                        />
                                    </td>

                                    <td>
                                        <Form.Check
                                            className="text-center"
                                            type="switch"
                                            id={"plantao" + colaborador.id_colaborador}
                                            label={<span>{<Headset />} Participou Plantão</span>}
                                            value={colaborador.id_colaborador}
                                        />
                                    </td>

                                </tr>
                            ))) : (colaboradores.map(colaborador => (

                                <tr key={colaborador.id_colaborador} id={colaborador.id_colaborador}>
                                    <td>{colaborador.nome}</td>
                                    <td>
                                        <Form.Check
                                            className="text-center"
                                            type="switch"
                                            id={"ajuste" + colaborador.id_colaborador}
                                            label={<span>{<Adjust />} Sem ajuste</span>}
                                            value={colaborador.id_colaborador}
                                        />
                                    </td>
                                    <td>
                                        <Form.Check
                                            className="text-center"
                                            type="switch"
                                            id={"atraso" + colaborador.id_colaborador}
                                            label={<span>{<Clock />} Sem atraso</span>}
                                            value={colaborador.id_colaborador}
                                        />
                                    </td>
                                    <td>
                                        <Form.Check
                                            className="text-center"
                                            type="switch"
                                            id={"batida_remota" + colaborador.id_colaborador}
                                            label={<span>{<Mobile />} Sem batida remota</span>}
                                            value={colaborador.id_colaborador}
                                        />
                                    </td>

                                    <td>
                                        <Form.Check
                                            className="text-center"
                                            type="switch"
                                            id={"plantao" + colaborador.id_colaborador}
                                            label={<span>{<Headset />} Participou Plantão</span>}
                                            value={colaborador.id_colaborador}
                                        />
                                    </td>

                                </tr>
                            )))
                        }
                    </tbody>
                </Table>
                <button className="btn-icones p-1 rounded btn-icones" style={{width: 200, height: 50}} onClick={async () => atribuicaoMultipla()} ><Salvar /><span className="pt-1"> Atribuir</span></button>
            </div>
        </div>}
    </>
}

export default AtribuicaoMilhas;